import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const IndustryField = ({ industrySelectOptions }) => {
  return (
    <Field name="industry" parse={values => values.map(({ value }) => value)}>
      {({ input }) => (
        <Fragment>
          <label>Industry</label>
          <Select {...input} multi options={industrySelectOptions} className="form-select" />
        </Fragment>
      )}
    </Field>
  );
};

IndustryField.propTypes = {
  industrySelectOptions: PropTypes.array.isRequired,
};

export default IndustryField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/IndustryField.jsx